import { ShiftDifferentialType } from '~/types/hlx/enums';

export const SHIFT_DIFF_TYPE_OPTIONS = [
  { label: 'Incremental Amount ($/hour)', value: ShiftDifferentialType.INCR_HOURLY_RATE },
  { label: 'Multiplier (x Base Rate)', value: ShiftDifferentialType.MULTIPLIER },
  { label: 'RVU Rate', value: ShiftDifferentialType.RVU },
  { label: 'Fixed Hourly Rate', value: ShiftDifferentialType.HOURLY_RATE },
];

export const emptyShiftDetailsForm = {
  // Shift Allocation
  numDayShifts: 0,
  numEveShifts: 0,
  numNightShifts: 0,
  numOfWeDayShifts: 0,
  numOfWeEveShifts: 0,
  numOfWeNightShifts: 0,
  numHolDayShifts: 0,
  numHolEveShifts: 0,
  numHolNightShifts: 0,
  // Shift Differentials
  shiftDiffType: SHIFT_DIFF_TYPE_OPTIONS[0],
  eveShiftRateDiff: 0,
  nightShiftRateDiff: 0,
  weDayShiftRateDiff: 0,
  weEveShiftRateDiff: 0,
  weNightShiftRateDiff: 0,
  holDayShiftRateDiff: 0,
  holEveShiftRateDiff: 0,
  holNightShiftRateDiff: 0,
};
